import appStrings from '@/assets/constants/appStrings-no.ts';
import FaqList from '@/components/FaqList/index.ts';
import Page from '@/components/Page/index.ts';
import Section from '@/components/Section/index.ts';

import ContactInfo from './ContactInfo/ContactInfo.tsx';

export default function CustomerService() {
  return (
    <Page title={appStrings.MENU.CUSTOMER_SERVICE}>
      <Section background="paper">
        <ContactInfo />
      </Section>
      <Section last>
        <FaqList />
      </Section>
    </Page>
  );
}
